import { Popper } from "@material-ui/core";
import React, { useRef, useState } from "react";
import { connect } from "react-redux";
import { isSheetPerPeriod } from "src/configState/selector";
import { State } from "src/state";
import { showAlertBanner } from "../../shared/alertBanner/actions";
import { ALERT_BANNER_TYPES } from "../../shared/alertBanner/reducer";
import { getSpreadId } from "../../spread/model/spread/selector";
import { exportReport, ExportReportActionType } from "../model/spread/actions";
import ExportIcon from "./export-icon.svg";

const MESSAGES = {
  SUCCESS: "Report exported successfully",
  FAIL: "Failed to export report",
  HOVER_TEXT: "Export to Excel"
};

interface ExportButtonProps {
  exportReportAction: ExportReportActionType;
  spreadId: string;
  sheetPerPeriod: boolean | undefined;
  showAlertBannerAction: typeof showAlertBanner;
}

const ExportButton: React.SFC<ExportButtonProps> = ({
  spreadId,
  sheetPerPeriod,
  exportReportAction,
  showAlertBannerAction
}) => {
  const [hoverText, setHoverText] = useState("");
  const [imgEl, setImgEl] = useState(null);
  const imgRef = useRef(null);

  const setHoverState = () => {
    setImgEl(imgRef.current);
    setHoverText(MESSAGES.HOVER_TEXT);
  };

  const resetHoverState = () => {
    setImgEl(null);
    setHoverText("");
  };

  const showSuccessBanner = () => {
    showAlertBannerAction({
      type: ALERT_BANNER_TYPES.SUCCESS,
      message: MESSAGES.SUCCESS
    });
  };

  const showErrorBanner = () => {
    showAlertBannerAction({
      type: ALERT_BANNER_TYPES.ERROR,
      message: MESSAGES.FAIL
    });
  };

  const handleOnClick = () => {
    exportReportAction({ spreadId, sheetPerPeriod })
      .then(showSuccessBanner)
      .catch(showErrorBanner);
  };

  return (
    <>
      <img
        src={ExportIcon}
        className="ExportReport__button"
        onClick={handleOnClick}
        onMouseOver={setHoverState}
        onMouseOut={resetHoverState}
        ref={imgRef}
      />
      <Popper open={Boolean(hoverText)} placement="top" anchorEl={imgEl}>
        <div className={"Popper"}>{hoverText}</div>
      </Popper>
    </>
  );
};

const mapStateToProps = (state: State) => ({
  spreadId: getSpreadId(state),
  sheetPerPeriod: isSheetPerPeriod(state)
});

export default connect(
  mapStateToProps,
  {
    exportReportAction: exportReport.action,
    showAlertBannerAction: showAlertBanner
  }
)(ExportButton);



// WEBPACK FOOTER //
// ./src/spread/chartOfAccounts/ExportButton.tsx